import {
	BaseRegisteredExtension,
	ExtensionContextType,
	ExtensionManifest,
	ExtensionPermissions,
	ExtentionPriority,
	IRegisteredExtension,
	DEFAULT_MODULE_IDS,
	InternalCallState,
	IDynamicValue,
	IExecutionResult
} from '@elyx-code/project-logic-tree';
import { browserDeletePersistedEntityImplementation } from '../../../../execution/built-in-function-implementations';
import { EditorService } from '../../../EditorService';
import { Execution } from '../../../../execution';

export class BuiltInFunctionImplementationDeletePersistedEntityModule
	extends BaseRegisteredExtension
	implements
		IRegisteredExtension<{
			main: (
				entity: InternalCallState,
				inputs: IDynamicValue[],
				execution?: Execution
			) => Promise<IExecutionResult>;
		}>
{
	manifest: ExtensionManifest = {
		id: DEFAULT_MODULE_IDS.BUILT_IN_FUNCTION_IMPLEMENTATIONS__DELETE_PERSISTED_ENTITY,
		version: '1.0.0',
		description:
			'Implementation for the built-in function "Delete Persisted Entity". It deletes the current entity as an entry in the persisted storage.',
		initPriority: ExtentionPriority.High,
		permissions: [ExtensionPermissions.All],
		contexts: [ExtensionContextType.Editor, ExtensionContextType.Logic]
	};

	module = {
		main: (
			entity: InternalCallState,
			inputs: IDynamicValue[],
			execution?: Execution
		) => {
			const editorContext = this.extensionsRegistry.requestContexts(
				this,
				[ExtensionContextType.Editor]
			)[0] as EditorService;

			return browserDeletePersistedEntityImplementation(
				entity,
				inputs,
				editorContext,
				execution
			);
		}
	};
}
